var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"p-2 bg-dark rounded text-light font-weight-bold"},[_c('i',{staticClass:"fas fa-fw mr-2",class:_vm.icon}),_vm._v(_vm._s(_vm.labelText)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }